import i18n from "i18next";
import { Manage } from "@/Pages/Manage/Manage";
import Authenticated from "@/Layouts/Authenticated";
import styles from "@/../sass/components/Invoices.module.scss";
import { Card } from "@/Components/Card";
import { Link, usePage } from "@inertiajs/inertia-react";
import { showChargebeeSection, showChargeBeeUi } from "@/Utilities/ChargeBee";
import FlashMessage from "@/Components/FlashMessage";
import { useState } from "react";

const Invoices = () => {
    const props = usePage().props;

    const invoicesUrl = usePage().props.invoicesUrl
        ? usePage().props.invoicesUrl
        : "https://help.myamplify.io/hc/en-us/requests/new";

    const [chargebeeErrorMessage, setChargebeeErrorMessage] = useState(null);

    async function showChargebeeSubsciptions() {
        try {
            await showChargebeeSection(props, "BILLING_HISTORY");
        } catch (e) {
            setChargebeeErrorMessage(e.message);
        }
    }

    return (
        <Manage className={styles.title} title={i18n.t("manage.invoices")}>
            <div className="row">
                <div className="col-6">
                    <Card className={styles.invoiceCard}>
                        <div className={styles.invoiceCardHeader}>
                            <span className={styles.invoiceCardTitle}>
                                {i18n.t("billing.invoices")}
                            </span>
                        </div>
                        <div className={styles.emptyState}>
                            <div>
                                {showChargeBeeUi(props) ? (
                                    <div
                                        className={`${styles.requestInvoice} no-link`}
                                        onClick={showChargebeeSubsciptions}
                                    >
                                        View Invoices
                                    </div>
                                ) : (
                                    <Link
                                        href={invoicesUrl}
                                        className={
                                            styles.requestInvoice + " no-link"
                                        }
                                    >
                                        Request an Invoice
                                    </Link>
                                )}
                            </div>
                            <span>
                                <img src="/images/invoices.svg" />
                            </span>
                        </div>
                    </Card>
                </div>
                <div className="col-6">
                    <Card className={styles.invoiceCard}>
                        <div className={styles.invoiceCardHeader}>
                            <span className={styles.invoiceCardTitle}>
                                {i18n.t("billing.usage")}
                            </span>
                        </div>
                        <div className={styles.emptyState}>
                            <div>
                                <Link
                                    href={route("manage.usage-show")}
                                    className={
                                        styles.requestInvoice + " no-link"
                                    }
                                >
                                    {i18n.t("billing.view")}
                                </Link>
                            </div>
                            <span>
                                <Link
                                    href={route("manage.usage-show")}
                                    className={
                                        styles.requestInvoice + " no-link"
                                    }
                                >
                                    <img src="/images/usage.svg" />
                                </Link>
                            </span>
                        </div>
                    </Card>
                </div>
            </div>

            {chargebeeErrorMessage && (
                <FlashMessage
                    message={chargebeeErrorMessage}
                    type="danger"
                    hasClosed={() => setChargebeeErrorMessage(null)}
                />
            )}
        </Manage>
    );
};

Invoices.layout = (page) => <Authenticated children={page}></Authenticated>;
export default Invoices;
